    import { Box, Button, DialogActions,  IconButton,  TextField, Typography } from '@mui/material'
    import { Dialog, DialogContent, DialogTitle, Stack } from '@mui/material'
    import React, {  useState } from 'react'
    import { useTranslation } from 'react-i18next'
    import {  Edit } from '@mui/icons-material'
    import SelectResponsiblePerson from '../../Survey/components/SelectResponsiblePerson'
    import { flushSync } from 'react-dom'
    import { DateTimePicker } from '@mui/x-date-pickers'
    import { createQuestionnaire } from '../../../apis/questionnaireApis'
    import { CircularProgress } from '@mui/material'
    import { useDispatch } from 'react-redux'
    import { toastActions } from '../../../_actions'
    import QuestionnaireTemplateListModal from './QuestionnaireTemplateListModal'
    import EllipsisTypography from '../../../components/EllipsisTypography'

    const QuestionnaireCreationModal = ({ handleClose, buildingId, projectId,open }) => {
      const { t } = useTranslation()
      const dispatch = useDispatch()
      const [formData, setFormData] = useState({
        name : '',
        reportHeader: '',
        assignTo: '',
        scheduleDateTime: null
      });
      const [openTemplateListModal, setOpenTemplateListModal] = useState(false)
      const [errors, setErrors] = useState({})
      const [loading, setLoading] = useState(false)
      const [isSubmitting, setIsSubmitting] = useState(true);
      const [organizationsLoading, setOrganizationsLoading] = useState(false);
      const [anchorEl, setAnchorEl] = useState(null);
    
      const clearError = (name) => {
        const nameParts = name.split('.');
        const key = nameParts[0];
        const nestedKey = nameParts.slice(1).join('.');
        setErrors((prevErrors) => {
          if (nestedKey) {
            const newErrors = { ...prevErrors };
            delete newErrors[key]?.[nestedKey];
            if (Object.keys(newErrors[key] || {}).length === 0) {
              delete newErrors[key];
            }
            return newErrors;
          } else {
            const { [key]: _, ...rest } = prevErrors;
            return rest;
          }
        });
      };

      const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        clearError(name)
      };


      const validateCreateQuestionnaire = () => {
        let newErrors = {};

        if (!formData.name?.trim()) {
          newErrors.name = t("general.field.error");
        }

        if (!formData.templateName?.trim()) {
          newErrors.templateName = t("general.field.error");
        }

        if (!formData.reportHeader?.trim()) {
          newErrors.reportHeader = t("general.field.error");
        }

        if (!formData.scheduleDateTime) {
          newErrors.scheduleDateTime = t("general.field.error");
        }

        if (!formData.assignTo) {
          newErrors.assignTo = t("general.field.error");
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

      const handleCreateQuestionnaire = async () => {
        if (!validateCreateQuestionnaire()) return;
        const payload = {
          name: formData.name,
          questionnaireTemplateId : formData.questionnaireTemplateId ,
          reportHeader: formData.reportHeader,
          executorLoginId: formData.assignTo || '',
          plannedDate: formData.scheduleDateTime?.toISOString(),
          projectIds: projectId,
          buildingIds: buildingId,
        };

        try {
          setLoading(true);
        await createQuestionnaire(payload);
          dispatch(toastActions.success(t("questionnaire.createdSuccessfully")))
        } catch (error) {
          console.error("Create Survey Error:", error);
        } finally {
          handleClose();
          setLoading(false)

        }
      };

      const handleDateTimeChange = (value) => {
        setFormData((prev) => ({
          ...prev,
          scheduleDateTime: value
        }));
        clearError("scheduleDateTime");
      };

      const handleResponsibleSubmit = async (data) => {
        setFormData((prev) => ({
          ...prev,
          assignTo: data.loginId,
          responsibleName: data.person
        }));
        clearError("assignTo");
        setAnchorEl(null);
         setIsSubmitting(false);
      };

      const handleTemplateSelect = (row) => {
        setFormData((prev) => ({
          ...prev,
          templateName: row?.name || "",
          reportHeader: row?.reportHeader || "",
          questionnaireTemplateId : row?.id || ''
        }));
        clearError('templateName')
        clearError('reportHeader')
      };


      
      const handleCancelSurveyDialog = () => {
        handleClose()
      }

      return (
        <Dialog
          open={true}
        onClose={(event, reason) => reason === 'backdropClick' ? event.stopPropagation() : handleClose()} 
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              maxWidth: "none",
              width: 600,
            }
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {t("constructionquality.questionnaire")}
          </DialogTitle>
          <DialogContent sx={{ overflow: "visible" }}>
            <Stack spacing={2}>
              <TextField
                id="outlined-multiline-flexible"
                name="name"
                label={t("questionnaire.name")}
                value={formData?.name}
                onChange={handleChange}
                autoComplete='off'
                size="small"
                fullWidth
                error={!!errors?.name}
                helperText={errors?.name}
                slotProps={{
                  htmlInput: { maxLength: 100 },
                }}
              />
              <TextField
                id="outlined-multiline-flexible"
                name="templateName"
                label={t('general.template.name')}
                autoComplete='off'
                value={formData?.templateName}
                onClick={() => setOpenTemplateListModal(true)}
                size="small"
                fullWidth
                error={!!errors?.templateName}
                helperText={errors?.templateName}
                InputLabelProps={{
                  shrink: Boolean(formData?.templateName),
                }}
                slotProps={{
                  htmlInput: { maxLength: 100 ,readOnly: true},
                }}
              />
              <TextField
                id="outlined-multiline-flexible"
                name="reportHeader"
                label={t('questionnaire.reportHeader')}
                autoComplete='off'
                value={formData?.reportHeader}
                onChange={handleChange}
                size="small"
                fullWidth
                error={!!errors?.reportHeader}
                helperText={errors?.reportHeader}
                slotProps={{
                  htmlInput: { maxLength: 100 },
                }}
              />
              <DateTimePicker
                label={t("general.startDateTime")}
                value={formData.scheduleDateTime}
                onChange={handleDateTimeChange}
                minDateTime={new Date()}  
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    error: !!errors?.scheduleDateTime,
                    helperText: errors?.scheduleDateTime
                  }
                }}
              />

              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography fontWeight={500} ml={1}>
                  {t("general.responsible")}
                </Typography>

                <Stack direction="row" spacing={1} alignItems="center">
                  {formData?.responsibleName && (
                    <EllipsisTypography
                      component="div"
                      title={formData.responsibleName}
                    />
                  )}

                  <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                    {organizationsLoading ? (
                      <CircularProgress size={12} color="inherit" />
                    ) : (
                      <Edit />
                    )}
                  </IconButton>
                </Stack>
              </Stack>
              {errors?.assignTo && (
                <Typography sx={{ color: "error.main", fontSize: "12px", ml: 0.5 }}>
                  {errors.assignTo}
                </Typography>
              )}
            </Stack>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleCancelSurveyDialog}>{t("general.cancel")}</Button>
            <Button onClick={handleCreateQuestionnaire} loading={loading}   >
              {t("general.continue")}
            </Button>
          </DialogActions>

          {
            openTemplateListModal && <QuestionnaireTemplateListModal handleClose={() => setOpenTemplateListModal(false)} onSelect={handleTemplateSelect}
            />
          }
          <SelectResponsiblePerson
            loading={organizationsLoading}
            customTitle={t("general.responsible")}
            isSubmitting={isSubmitting}
            forQuestionnaireCreate
            onSubmit={(data) => handleResponsibleSubmit(data)}
            setLoading={(val) => {
              flushSync(() => {
                setOrganizationsLoading(val);
                setIsSubmitting(true);
              });
            }}
            anchorEl={anchorEl}
            onClose={() => {
              setAnchorEl(null)
            }}
             />
        </Dialog>
      )
    }

    export default QuestionnaireCreationModal
